@for (item of vacancies; track item) {
  <div class="mb-3">
    <div class="row g-0 border rounded">
      @if (item.teamPhotoUrl !== null && item.teamPhotoUrl.length > 0) {
        <div class="col-4 image-vacature" [style.background-image]="'url(' + item.teamPhotoUrl + ')'">
          <div class="image-overlay">
            <div><fa-icon [icon]="['fas', 'business-time']" class="text-white"></fa-icon> {{ item.availabilityName }}</div>
          </div>
        </div>
      } @else {
        <div class="col-4 image-vacature no-photo">
          <div class="image-overlay">
            <div><fa-icon [icon]="['fas', 'business-time']" class="text-white"></fa-icon> {{ item.availabilityName }}</div>
          </div>
        </div>
      }
      <div class="col-8 p-3">
        <p class="mb-1">
          <span class="text-primary fw-bold">Team {{ item.teamName }}</span>
        </p>
        <h5 class="fw-bold">
          {{ item.jobTitleName }} <span class="h6 text-muted">Niveau {{ item.jobTitleLevel }}</span>
        </h5>
        <p>
          {{ item.introductionText }}
        </p>
        <div class="d-flex justify-content-end">
          <a type="button" class="btn btn-primary" [href]="'http://werkenbijbuurtzorg.nl/vacature/' + item.documentId" target="_blank"
            >Bekijk vacature</a
          >
        </div>
      </div>
    </div>
  </div>
}
